var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowngrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    transform: "rotate(-180 9 9)",
    fill: "white",
    stroke: "#EB5A51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.5,
    transform: "rotate(-180 9 9)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 14.3333L9.55487 13.8159L13.4444 10.177L12.3346 8.80666L9.84554 11.1379L9.84554 3.66665L8.15443 3.66665L8.15443 11.1379L5.66531 8.80666L4.55554 10.177L8.4451 13.8159L8.99998 14.3333V14.3333Z",
    fill: "#EB5A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowngrade);
export default __webpack_public_path__ + "static/media/downgrade.efda01ff804825f7de2f0bd4a360b2de.svg";
export { ForwardRef as ReactComponent };